import React, { Component } from "react"
import { Helmet } from "react-helmet"
import { MetaData, structuredPageData } from "../../shared/structureData"
import * as imageAssets from "../../shared/images"
import { Query } from "react-apollo"
import { Redirect } from "react-router"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import GET_PAGE from "../../graphql/getPage.graphql"
import AppContext from "../../shared/AppContext"

import "./aboutEtrInsights.scss"

class AboutEtrInsights extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDiagram: "0",
    }
  }

  /**
   * [pageSEO description]
   * this information should be coming from DB
   */
  pageSEO = () => {
    let seo = {}
    seo.type = "website"
    seo.url = "https://app.etr.ai/etr-insights/about"
    seo.title = `ETR Insights About | ETR`
    seo.image = imageAssets.defaultLogo
    seo.description =
      "ETR Insights curated events and discussions are designed to complement the quantitative findings by Enterprise Technology Research, with vital qualitative reasoning."

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">
          {structuredPageData(seo.url)}
        </script>
      </Helmet>
    )
  }

  onLinkClicked = (e, description, from, url) => {
    e.preventDefault()
    this.props.trackEvent(event, {
      from: from,
    })
    this.props.history.push(url)
  }

  /**
   * [vennData description]
   * this information should be move to the DB
   */
  vennData = [
    {
      number: "1",
      title: "CIO",
      description:
        "Data-curated peer-to-peer and executive level vendor engagements that are devoid of sponsorship and bias.",
    },
    {
      number: "2",
      title: "Investor",
      description:
        "Direct feedback from key members of our enterprise technology ecosystem.",
    },
    {
      number: "3",
      title: "Vendor",
      description:
        "Purposeful and comprehensive connectivity with ETR’s CIO and investor communities.",
    },
    {
      number: "4",
      title: "ETR Insights",
      description:
        "A universal, interconnected, exchange of intelligence. Access an ongoing library of substantive data-driven content in the form of executive summaries, full transcripts, and replays.",
    },
  ]

  render() {
    return (
      <section id="about-venn">
        {this.pageSEO()}
        <h1 className="title">
          <img
            src={imageAssets.etrColorInsights}
            className="etr-insight-logo logo-lg"
            alt="ETR insights"
          />
          <span>AN EVENT + CONTENT PLATFORM BY ETR</span>
        </h1>
        <p className="venn-subheading">
          Curated events and discussions designed to complement ETR’s
          quantitative findings with vital qualitative reasoning.{" "}
          <a
            onClick={() =>
              this.props.openInquireModal(
                this.props.serviceType.UpgradePlan,
                "Venn About Page: Inquire For Pricing Button"
              )
            }
            data-cy="venn-about-inquire-button"
          >
            Inquire For Pricing.
          </a>
        </p>
        <div className="venn-hero">
          <div className="venn-hero-row">
            <div className="venn-diagram col">
              <div
                className="venn-diagram-image"
                data-diagram={this.state.selectedDiagram}
              ></div>
            </div>
            <div className="venn-description col">
              <ul className="venn-description-list">
                {this.vennData.map((item, idx) => {
                  return (
                    <li
                      key={idx}
                      onMouseEnter={() =>
                        this.setState({ selectedDiagram: item.number })
                      }
                      onMouseLeave={() =>
                        this.setState({ selectedDiagram: "0" })
                      }
                    >
                      <span className="number">{item.number}</span>
                      <h4 className="list-title">{item.title}</h4>
                      <p>{item.description}</p>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
        <p className="footer-text">
          A convergence of community and content, overlapping the intelligence
          of Investors, Vendors and CIOs.
        </p>
        <div className="venn-links">
          <a
            className="btn btn-marketing-style1 btn-outline"
            onClick={(e) =>
              this.onLinkClicked(
                e,
                "ETR Insights Calendar Button",
                "About ETR Insights",
                "/etr-insights/calendar"
              )
            }
          >
            ETR Insights Calendar
            <span className="fa fa-arrow-right icon hover-animate"></span>
          </a>
          <a
            className="btn btn-secondary"
            onClick={(e) =>
              this.onLinkClicked(
                e,
                "Search All ETR Insights Events button",
                "About ETR Insights",
                "/marketplace?reportType=VENN"
              )
            }
          >
            Search All ETR Insights
            <span className="fa fa-arrow-right icon hover-animate"></span>
          </a>
        </div>
      </section>
    )
  }
}

const AboutVennWithData = (homePageProps) => {
  if (!homePageProps.viewer || !homePageProps.viewer.isUserAuthenticated) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: "/etr-insights/about" } }}
      />
    )
  }
  return (
    <AppContext.Consumer>
      {({ openInquireModal, serviceType }) => {
        return (
          <Query query={GET_PAGE} variables={{ slug: "/" }}>
            {(queryProps) => {
              return (
                <ApolloQueryHandler {...queryProps} {...homePageProps}>
                  {(props) => (
                    <AboutEtrInsights
                      {...props}
                      openInquireModal={openInquireModal}
                      serviceType={serviceType}
                    />
                  )}
                </ApolloQueryHandler>
              )
            }}
          </Query>
        )
      }}
    </AppContext.Consumer>
  )
}

export default AboutVennWithData
